import { SharedPatientAssistancePharmacyPaymentStatementAggregatedStatusType } from '@libs/shared/domain/patient-assistance/pharmacy/payment-statement/shared-patient-assistance-pharmacy-payment-statement-aggregated-status.type';

export const PHARMACY_PAYMENT_STATEMENT_AGGREGATED_STATUS_LABEL_MAPPER: Record<
  SharedPatientAssistancePharmacyPaymentStatementAggregatedStatusType,
  string
> = {
  paid: 'Paid',
  unpaid: 'Unpaid',
  closed: 'Closed',
  pending: 'Pending',
  paidAdjusted: 'Paid - Adjusted',
  unpaidAdjusted: 'Unpaid - Adjusted',
  closedAdjusted: 'Closed - Adjusted',
  pendingAdjusted: 'Pending - Adjusted',
};
